export const CurrentProductJoinableUser = () => {
    return (
        <div
            data-testid="site-activation"
            data-cohort="current-product-joinable-user"
        >
            Logged In Jira Free - Current Product Joinable User
        </div>
    );
};
